import React, {useEffect, useState, Fragment, useMemo} from 'react';
import {Button, Col, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import {service as ProcedureService} from "../../../Services/ProcedureService";
import {service as SampleEventPhaseService} from "../../../Services/SampleEventPhaseService";
import {service as SampleEventService} from "../../../Services/SampleEventService";
import {StreamBankLink} from "../../Common/StreamBankLink";
import IconUtils from "../../../../../monitoring/src/Utils/IconUtils";
import DateUtils from "../../../../../monitoring/src/Utils/DateUtils";
import {usePrimeCache} from "../../../Hooks/ServiceHooks";
import * as PropTypes from "prop-types";

function EventListItem(props) {
    const {event} = props;

    if(!usePrimeCache([ProcedureService])) {
        return null;
    }
    
    const procedure = ProcedureService.CachedValueById(event.procedureId)?.result;
    const eventDate = DateUtils.FormatToLocalDateTime(event.startDate, "MMM d, yyyy");
    
    return <dd>
        <StreamBankLink
            Context={
                event?.ConservationActionSampleEvents?.[0]?.ConservationAction?.ContextNodeDetails?.link
                + "/" + event.sampleEventId
            }
            Tool="summary"
        >
            <FontAwesomeIcon icon={['fas', IconUtils.GetProcedureIconName(procedure?.code)]} fixedWidth/>
            <span>{eventDate} </span>
            { event.otherPurpose && <span className="other-purpose">- {event.otherPurpose}</span> }
            {/*{ SampleEventService.eventIsScheduled(event) && <span className="is-scheduled">- <FontAwesomeIcon icon={['fas', 'calendar']}/> Scheduled</span> }*/}
        </StreamBankLink>
    </dd>;
}

EventListItem.propTypes = {
    event: PropTypes.any,
    procedure: PropTypes.any
};
export const RecentEvents = (props) => {
    const [sampleEvents, setSampleEvents] = useState(null);
    
    usePrimeCache([SampleEventPhaseService]);
    const sampleEventPhases = SampleEventPhaseService.CachedValues()?.result ?? null;
    
    const sampleEventPhaseIds = useMemo(() => {
        const relevantPhaseIds = new Set((sampleEvents ?? []).map((event) => event.sampleEventPhaseId).sort().reverse());
        return Array.from(relevantPhaseIds).splice(0, 2);
    }, [sampleEvents]);

    useEffect(() => {
        void loadData(props.contextNodeId);
    }, [props.contextNodeId]);
    
    const loadData = async (contextNodeId) => {
        try {
            const sampleEventResult = await SampleEventService.GetWithContext({
                contextNodeId: contextNodeId,
                sampleEventTypeId: 1,
            });
            
            console.log(123, sampleEventResult)
            setSampleEvents(sampleEventResult?.result ?? []);
        } catch (x) {
            setSampleEvents([]);
        }
    };
    
    const renderEventList = () => {
        if(sampleEventPhaseIds === null || sampleEvents === null || sampleEventPhases === null) {
            return <dd>Loading...</dd>;
        }
        
        let result = sampleEventPhaseIds.map(phaseId => {
            const currentPhase = sampleEventPhases.find(phase => phaseId === phase.sampleEventPhaseId);
            return <Fragment key={phaseId}>
                <dt>{currentPhase?.name}</dt>
                {
                    sampleEvents.filter(event => event.sampleEventPhaseId === phaseId).map(event =>
                        <EventListItem
                            key={event.sampleEventId}
                            event={event}
                        />
                    )
                }
            </Fragment>
        })
        
        if(!result.length) {
            return "No Events";
        }

        result = result.concat(
            <Fragment key="more">
                <dt><StreamBankLink Tool="events">
                    <Button className="sb-recent-events-more-btn">More</Button>
                </StreamBankLink></dt>
            </Fragment>
        );
        
        return result;
    }

    return (
        <Row className="sb-recent-events-list">
            <Col xs={12} className="sb-recent-events-list-node">
                <h2 className="sb-children-list-title">Recent Events</h2>
                <dl className="sb-recent-events-list">
                    { renderEventList()}
                </dl>
            </Col>
        </Row>
    )
};


